import React from "react";
import { defaultDropList, defaultAttributeList } from "../Data/WBComponentDefaults";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { WBComponent } from "./WBComponent";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";


export default class BusinessStaff extends WBComponent {
    constructor() {
        super();
        this.typename = wBComponentTypeNames.busienssStaff;
        this.displayName = "Staff";
        this.dropList = defaultDropList;
        this.colorFields = ["staffImgBorderColor","condPanelColor","starColor"];
        this.editList = [...this.colorFields,"staffImgBorder","staffImgBorderColor","staffLayout","staffImgRadius","staffImgShadow","showReviews",componentAttributeTypes.multiLocation, ...defaultAttributeList, attributeTypes.gap,componentAttributeTypes.visibility,componentAttributeTypes.customCSS];
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation,"staffLayout","staffImgBorder","staffImgRadius","staffImgShadow", "showReviews" ];


        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor"><path d="M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z" /></svg>;
        this.vagaroLink = "http://www.vagaro.com/merchants/employee";
        this.cssDefinitions =[
            new NodeCSSClassDefinition(".staff-image-border",
            [
                {key:"staffImgBorder",cssProperty:"border-width",default:"0"},
            
                {key:"staffImgBorderColor",cssProperty:"border-color",default:""},
                {key:"X",cssProperty:"border-style",default:"solid"}, 
                {key:"staffImgRadius",cssProperty:"border-radius",default:""},
                {key:"staffImgShadow",cssProperty:"box-shadow",default:""}
             ]),
            
             new NodeCSSClassDefinition(".staff-grid-item",[
                {key:"panelColor",cssProperty:"background-color",default:"#ffffff"},
             ]),
             new NodeCSSClassDefinition(".staff-reviews",[
                {key:"showReviews",cssProperty:"display",default:""}
             ])
            ]
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("staffLayout", "Layout", "", AttributeInputType.SelectField, [
                { label: "Default", value: "default" },
                { label: "Cards", value: "2" },
                { label: "Circles", value: "3" },
                { label: "Mini Circles", value: "4" },
                { label: "Alternating", value: "5" },
                { label: "Rectangles", value: "6" },

            ]),
            CreateConditionalAttribute("condPanelColor", "panelColor", [{ key: "staffLayout", value: "2" }]),

            new AttributeDefinition("staffImgBorder", "Image Border Width", "", AttributeInputType.FourwayMeasurmentField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "1px" },
                    { label: "M", value: "3px" },
                    { label: "L", value: "6px" }

                ], { min: 0, max: 20, step: 1, unit: "px", default: 0 }),

            new AttributeDefinition("staffImgBorderColor", "Image Border Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("staffImgRadius", "Image Border Radius", "", AttributeInputType.MeasurementField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "4px" },
                    { label: "M", value: "20px" },
                    { label: "L", value: "40px" }

                ], { min: 0, max: 200, step: 1, unit: "px", default: 0 }),


            new AttributeDefinition("staffImgFit", "Image Fit", "", AttributeInputType.SelectField, [
                { label: "Cover", value: "cover" },
                { label: "Contain", value: "contain" },
                { label: "Fill", value: "fill" }
            ]),
            new AttributeDefinition("staffImgShadow", "Image Shadow", "", AttributeInputType.ShadowField,
                [
                    { label: "Auto", value: "" },
                    { label: "Off", value: "none" },
                    { label: "S", value: "0px 2px 16px 6px #00000044" },
                    { label: "M", value: "0px 3px 32px 8px #00000066" },
                    { label: "L", value: "0px 4px 48px 12px #00000088" },


                ]),

                new AttributeDefinition("showReviews", "Show Staff Reviews","", AttributeInputType.ButtonField, [
                    { label: "Show", value: "" },
                    { label: "Hide", value: "none" },
            
                ]),
        ]
    }


    
    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        // thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"16px"};
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);

    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("flex-column max-w-100 min-w-320 clamp-height scrollable w-full vb-control resizable-container", component, screenSize, isEditor);

        const layoutId = getNodeComponentAttributeValue(component, "staffLayout", "1");

        if (!isEditor) {
            return <BusinessPlaceHolder dataKey={BusienssControlNames.staff} layout={layoutId} node={component} classNames={atts.className} />
        }

        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                <style>
                    {super.GetComponentGlobalCSS(component,isEditor)}
                </style>
                <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layoutId} dataKey={"staff"} node={component} userContext={siteData} />
            </div>

        )
    }

}
